import { useLocation } from "react-router-dom";
import { usePageSeo } from "../../hooks/usePageSeo";

/**
 * Applies CMS-managed page SEO meta (PageSeoMetas) to the document head.
 */
const PageSeoHead = () => {
  const { pathname } = useLocation();
  usePageSeo(pathname);
  return null;
};

export default PageSeoHead;
